<div class="content-header">
    <div class="logo-and-title">
        <img src="/assets/images/v2/icons/leaderboard.svg" class="logo">
        <div>
            <div class="username">Wagering champions</div>
            <h5>Leadeboard</h5>
        </div>
    </div>
</div>
<div class="content-body">
    <div class="leaderboard-item" *ngFor="let item of logs; let i = index">
        <div class="leaderboard-item-content">
            <div class="leaderboard-position">
                <img *ngIf="i == 0" src="/assets/images/v2/icons/leaderboard-top1.svg">
                <img *ngIf="i == 1" src="/assets/images/v2/icons/leaderboard-top2.svg">
                <img *ngIf="i == 2" src="/assets/images/v2/icons/leaderboard-top3.svg">
                <span *ngIf="i > 2">{{ i + 1 }}</span>
            </div>
            <div class="leaderboard-user">
                <div class="user-info-wrap">
                    <app-user-avatar [user]="item?.user"></app-user-avatar>
                    <p *ngIf="item?.user?.username">{{ item?.user?.username }}</p>
                    <p *ngIf="!item?.user?.username" class="text-muted">Hidden</p>
                </div>
            </div>
            <div class="leaderboard-value">
              <div class="amount"><span>{{ item?.profit | crypto : currency : false : true : true }}</span><span>&nbsp;{{ currency.toString().toUpperCase() }}</span></div>
                <img src="/assets/images/v2/icons/leaderboard-coins.svg">
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/leaderboard-bets-wrapper/leaderboard/leaderboard.template.html